import find from 'lodash/find';
import assign from 'lodash/assign';
import uiRouter from '@uirouter/angularjs';

import { SubscriptionServiceModule } from 'services/access/subscription/subscription.service';
import { ExtensionServiceModule } from 'services/data/extension.service';
import { AppsServiceModule } from 'services/data/apps.service';
import { ImageManagerModule } from 'components/imageManager/imageManager.module';
import { VlnBackImageModule } from 'directives/vlnBackImage.directive';
import { AppBadgeModule } from 'components/appBadges/appBadge.component';

import template from './appExtensionPreview.html';
import './appExtensionPreview.scss';

export const AppExtensionPreviewModule = angular
    .module('app.components.appExtensionPreview.appExtensionPreview', [
        'ngMaterial',
        uiRouter,
        SubscriptionServiceModule,
        ExtensionServiceModule,
        AppsServiceModule,
        ImageManagerModule,
        VlnBackImageModule,
        AppBadgeModule
    ]).component('appExtensionPreview', {
        template,
        bindings: {
            app: '<',
            appType: '@',
            isInstalled: '<'
        },
        controller: class AppExtensionPreview {
            constructor(
                $scope,
                $mdDialog,
                appsService,
                extensionService,
                $state,
                $q,
                subscriptionsService
            ) {
                'ngInject';

                assign(this, {
                    $scope,
                    $mdDialog,
                    appsService,
                    extensionService,
                    $state,
                    $q,
                    subscriptionsService,
                    isInstalled: false,
                    isLoading: true,
                    gtmid: `admin_${$state.current.name}`
                });
            }

            $onInit() {
                this.setIsInstalledFlag();
            }

            closePreview() {
                this.$mdDialog.cancel('cancel');
            }

            setIsInstalledFlag() {
                if (this.isExtension()) {
                    this.$q.all([
                        this.extensionService.getTenantExtensions(),
                        this.subscriptionsService.getSubscription()
                    ]).then(([getTenantExtensionsResponse, getSubscriptionResponse]) => {
                        this.installedExtensions = getTenantExtensionsResponse;
                        this.isInstalled = find(this.installedExtensions, { extensionId: this.app.id });
                        this.showUpsell = !this.isInstalled
                            && !this.isFeatureAvailableInSubscription(getSubscriptionResponse, this.app.sku);
                        this.isLoading = false;
                    });
                } else if (this.isApplication()) {
                    this.isInstalled = this.app.enabled;
                    this.subscriptionsService.getSubscription().then((subscription) => {
                        this.showUpsell = !this.isInstalled
                            && !this.isFeatureAvailableInSubscription(subscription, this.app.sku);
                        this.isLoading = false;
                    });
                }
            }

            isApplication() {
                return this.appType === 'application';
            }

            isExtension() {
                return this.appType === 'extension';
            }

            isFeatureAvailableInSubscription(subscription, featureName) {
                return angular.isUndefined(subscription.features[featureName])
                    || subscription.features[featureName] === true;
            }

            installClicked() {
                // hide() resolves the promise on the launching $mdDialog, executing the .then() block there.
                // This in turn launches the appExtensionConfirmInstall component.
                // See launchAppExtensionPreview.service.js - launchPreview() to follow the chain.
                this.$mdDialog.hide(); // <- dark magic
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/appExtensionPreview/appExtensionPreview.component.js